var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5291 7.77C17.4591 7.76 17.3891 7.76 17.3191 7.77C15.7691 7.72 14.5391 6.45 14.5391 4.89C14.5391 3.3 15.8291 2 17.4291 2C19.0191 2 20.3191 3.29 20.3191 4.89C20.3091 6.45 19.0791 7.72 17.5291 7.77Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7916 14.7C19.6716 15.45 18.1016 15.73 16.6516 15.54C17.0316 14.72 17.2316 13.81 17.2416 12.85C17.2416 11.85 17.0216 10.9 16.6016 10.07C18.0816 9.87001 19.6516 10.15 20.7816 10.9C22.3616 11.94 22.3616 13.65 20.7916 14.7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43625 7.77C6.50625 7.76 6.57625 7.76 6.64625 7.77C8.19625 7.72 9.42625 6.45 9.42625 4.89C9.42625 3.29 8.13625 2 6.53625 2C4.94625 2 3.65625 3.29 3.65625 4.89C3.65625 6.45 4.88625 7.72 6.43625 7.77Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54719 12.85C6.54719 13.82 6.75719 14.74 7.13719 15.57C5.72719 15.72 4.25719 15.42 3.17719 14.71C1.59719 13.66 1.59719 11.95 3.17719 10.9C4.24719 10.18 5.75719 9.89 7.17719 10.05C6.76719 10.89 6.54719 11.84 6.54719 12.85Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1169 15.87C12.0369 15.86 11.9469 15.86 11.8569 15.87C10.0169 15.81 8.54688 14.3 8.54688 12.44C8.55687 10.54 10.0869 9 11.9969 9C13.8969 9 15.4369 10.54 15.4369 12.44C15.4269 14.3 13.9669 15.81 12.1169 15.87Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86687 17.94C7.35687 18.95 7.35687 20.61 8.86687 21.61C10.5869 22.76 13.4069 22.76 15.1269 21.61C16.6369 20.6 16.6369 18.94 15.1269 17.94C13.4169 16.79 10.5969 16.79 8.86687 17.94Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.2a8394232b1e65cc7ccc361b3925fa65.svg";
export { ForwardRef as ReactComponent };